<div class="page-container" [testId]="'account-list-page'">
  <div class="search-section" [testId]="'account-search-section'">
    <div nz-row [nzGutter]="24" class="search-row">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="search-input-container">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="'account-search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'account.list.search-placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'account-search-input'"
          />
          <ng-template #suffixIconSearch>
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'account.list.search-tooltip' | i18n"
              [testId]="'account-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          nz-button
          nzType="default"
          (click)="reset()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'common.reset' | i18n"
          [testId]="'account-reset-button'"
        >
          <i nz-icon nzType="clear" [testId]="'account-reset-icon'"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- 可滚动的内容区域 -->
  <div class="table-section" [testId]="'account-table-section'">
    <nz-table
      #basicTable
      class="content-table"
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzLoading]="loading"
      nzSize="small"
      [nzScroll]="{ x: '100%', y: 'calc(100vh - 200px)' }"
      [testId]="'account-table'"
    >
      <thead>
        <tr [testId]="'account-table-header'">
          <th scope="col" nzWidth="60px" nzLeft class="text-center row-number-column" [testId]="'account-serial-header'">
            {{ 'common.serial-number' | i18n }}
          </th>
          <th scope="col" *ngFor="let column of columns" [testId]="'account-header-' + column.key">{{ column.title }}</th>
          <th scope="col" nzRight [testId]="'account-actions-header'">{{ 'common.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index" (dblclick)="viewAccount(data.id)" [testId]="'account-row-' + data.id">
          <td nzLeft class="text-center row-number-column" [testId]="'account-serial-cell'">{{ i + 1 }}</td>
          <td *ngFor="let column of columns" [testId]="'account-cell-' + column.key">
            <span class="truncate-text" [title]="data[column.key]">
              <ng-container *ngIf="column.key === 'createTime' || column.key === 'updateTime'; else normalContent">
                {{ data[column.key] | date: 'yyyy-MM-dd HH:mm:ss.SSS' }}
              </ng-container>
              <ng-template #normalContent>
                {{ data[column.key] }}
              </ng-template>
            </span>
          </td>
          <td nzRight [testId]="'account-actions-cell'">
            <a (click)="viewAccount(data.id)" class="view-link" [testId]="'account-view-link'">{{ 'common.view' | i18n }}</a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div class="pagination-section" *ngIf="total > 0" [testId]="'account-pagination-section'">
    <div class="pagination-info" [testId]="'account-pagination-info'">{{ 'common.total-records' | i18n: { total: total } }}</div>
    <div class="pagination-controls">
      <nz-pagination
        nzSize="small"
        [nzShowQuickJumper]="true"
        [nzPageIndex]="pageIndex"
        [nzTotal]="total"
        [nzPageSize]="pageSize"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        (nzPageIndexChange)="nzPageIndexChange($event)"
        (nzPageSizeChange)="nzPageSizeChange($event)"
        [testId]="'account-pagination'"
      />
    </div>
  </div>
</div>
